import { Customer, Staff } from './types.tsx';
import { Role } from './enums.tsx';
import { isStaff } from './typeAssertionFunctions.tsx';

export function hasAdminRole(user: Staff | Customer | null): boolean {
  return isStaff(user) && user?.roleName === Role.Admin;
}
